import { __rest } from "tslib";
import { ProductActionTypes } from '@state/features/common.types';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
const AnimatedLink = (props) => {
    const { to, from, productId, children, className, ariaLabel, ariaHidden, tabIndex, product, trackingAction, originalUuid } = props, rest = __rest(props, ["to", "from", "productId", "children", "className", "ariaLabel", "ariaHidden", "tabIndex", "product", "trackingAction", "originalUuid"]);
    const dispatch = useDispatch();
    const el = useRef(null);
    const history = useHistory();
    const location = useLocation();
    const pathname = typeof to == 'string' ? to : to === null || to === void 0 ? void 0 : to.pathname;
    const state = typeof to == 'object' && to.state ? to.state : {};
    const linkProps = Object.assign({ to() {
            const mergedState = Object.assign(Object.assign({}, state), { transition: {
                    productId,
                    direction: 'in',
                    productUuid: originalUuid,
                }, viewport: {
                    scrollY: 0,
                } });
            return {
                pathname,
                state: mergedState,
            };
        },
        onClick(event) {
            event.stopPropagation();
            dispatch({
                type: ProductActionTypes.SET_PRODUCT,
                payload: product,
            });
            if (trackingAction) {
                trackingAction(event);
            }
            // const rect = el.current.getBoundingClientRect();
            // const filterHeight = document.querySelector('.refine')?.clientHeight;
            // let header = document.querySelector('header');
            // const headerHeight = header && header.clientHeight;
            // const headerGap = (filterHeight || 0) + headerHeight;
            const newLocation = location.pathname + window.location.search;
            const mergedState = Object.assign(Object.assign({}, from), { transition: {
                    productId,
                    direction: 'out',
                }, viewport: {
                    scrollY: window.scrollY,
                    // scrollY: window.scrollY + rect.top - headerGap,
                } });
            history.replace(newLocation, mergedState);
        } }, rest);
    return (React.createElement(Link, Object.assign({ ref: el }, linkProps, { className: className, "aria-label": ariaLabel, "aria-hidden": ariaHidden, tabIndex: tabIndex }), children));
};
export default AnimatedLink;
